import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=35cf0b58&scoped=true"
import script from "./LeftNavigation.vue?vue&type=script&lang=ts"
export * from "./LeftNavigation.vue?vue&type=script&lang=ts"
import style0 from "./LeftNavigation.vue?vue&type=style&index=0&id=35cf0b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf0b58",
  null
  
)

export default component.exports